import { useQuery } from '@tanstack/react-query';
import { API_GET_AI_ASSISTANT_MEMBERSHIP_LEGAL_FRONTDOOR } from 'constants/appConstants';
import axios from 'constants/axios';
import type { ApiGetResponseWithStatus } from 'interfaces';
import { statusIsOk } from 'utils/api';

import type { Membership } from '../permissions';
import { aiAssistantMembershipKeys } from './queryKeys';

interface UseGetAIAssistantMembershipParams {
  id: string;
  onError?: (error: unknown) => void;
  onSuccess?: (data: Membership) => void;
}

export const useGetAIAssistantMembership = ({
  id,
  onError,
  onSuccess,
}: UseGetAIAssistantMembershipParams) => {
  const { data, error, isError, isLoading, refetch } = useQuery({
    queryKey: aiAssistantMembershipKeys.detail(id),
    queryFn: async () => {
      const url = API_GET_AI_ASSISTANT_MEMBERSHIP_LEGAL_FRONTDOOR(id);
      const res = await axios.get<ApiGetResponseWithStatus<Membership>>(url);
      if (!statusIsOk(res)) {
        throw Object.assign(
          new Error(
            res.data.error?.description ||
              'Error fetching AI Assistant App Membership'
          ),
          { response: res, status: res.status, data: res.data }
        );
      }
      return res.data.result;
    },
    enabled: !!id,
    onError,
    onSuccess,
    refetchOnWindowFocus: false,
  });

  return { data, error, isError, isLoading, refetch };
};
